# Archived guides

import { ArchivedGuides } from './archived';

<ArchivedGuides />
